import React, { useState, useRef, useEffect } from "react";
import { TagInput, Dropdown, MenuItem } from "rsuite";
import { toast } from "react-toastify";

const EmailSuggestions = ({
  value = [],
  onChange,
  suggestionsSource = [],
  placeholder = "Add tags",
  validate = () => true,
  errorMessage = "Invalid input",
  style = { },
}) => {
  const [searchText, setSearchText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const containerRef = useRef(null);

  const handleSearch = (val) => {
    setSearchText(val);
    if (val) {
      const filtered = suggestionsSource.filter(
        (item) =>
          item.toLowerCase().includes(val.toLowerCase()) &&
          !value.includes(item)
      );
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  };

  const handleTagChange = (val) => {
    if (val.length > value.length) {
      const newTag = val.find((v) => !value.includes(v));
      if (!validate(newTag)) {
        toast.error(errorMessage);
        return;
      }
    }

    onChange(val);
  };

  const handleSelect = (item) => {
    if (!value.includes(item)) {
      if (!validate(item)) {
        toast.error(errorMessage);
        return;
      }

      onChange([...value, item]);
    }

    setSearchText("");
    setSuggestions([]);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setSuggestions([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={containerRef} style={{ position: "relative", ...style }}>
      <TagInput
        value={value}
        onChange={handleTagChange}
        onSearch={handleSearch}
        inputValue={searchText}
        onInputChange={setSearchText}
        placeholder={placeholder}
        trigger="Enter"
        style={{ width: "100%" }}
      />

      {searchText && suggestions.length > 0 && (
        <Dropdown
          open
          style={{
            position: "absolute",
            top: "100%",
            left: "0",
            width: "100%",
            zIndex: 1000,
          }}
          placement="bottomStart"
        >
          {suggestions.map((item, index) => (
            <Dropdown.Item key={index} onClick={() => handleSelect(item)}>
              {item}
            </Dropdown.Item>
          ))}
        </Dropdown>
      )}
    </div>
  );
};

export default EmailSuggestions;
